export class RuntimeError extends Error {
  override name = 'RuntimeErrorOccurred';
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public error: any;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(error: any) {
    super(
      ['Runtime Error', typeof error === 'string' ? error : undefined]
        .filter(Boolean)
        .join(': ')
    );
    this.error = error;
  }
}
